import {
  URL_ACCOUNT_INVOICING_HISTORY,
  URL_ACCOUNT_INVOICING_PAYABLE,
  URL_ACCOUNT_LEGACY_PAY_INVOICES,
  URL_ACCOUNT_PAY_INVOICES,
} from '@seek/adv-constants';

// app routes
export const ROUTE_ROOT = `/invoicing/`;
export const ROUTE_PAYABLE = URL_ACCOUNT_INVOICING_PAYABLE;
export const ROUTE_HISTORY = URL_ACCOUNT_INVOICING_HISTORY;
export const ROUTE_PAY = URL_ACCOUNT_PAY_INVOICES;
export const ROUTE_PAY_LEGACY = URL_ACCOUNT_LEGACY_PAY_INVOICES;
export const ROUTE_VIRTUAL_ACCOUNTS = `${ROUTE_PAY}/virtual-accounts`;
export const ROUTE_ERROR_NOT_FOUND = '/error/notfound';
